import FormattedMessage from 'I18n/components/FormattedMessage';
import { Drawer } from 'breeze-intelligence-kit';
import { DataTestContent } from './DataTestContent';
import { DataTestFooter } from './DataTestFooter';
import { useDataTest } from './useDataTest/useDataTest';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DataTestPanel() {
  const {
    onClose
  } = useDataTest();
  return /*#__PURE__*/_jsxs(Drawer, {
    inlineSize: 680,
    isOpen: true,
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(Drawer.Header, {
      children: /*#__PURE__*/_jsx(Drawer.Heading, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dataTest.panel.title"
        })
      })
    }), /*#__PURE__*/_jsx(DataTestContent, {}), /*#__PURE__*/_jsx(DataTestFooter, {})]
  });
}